import dayjs from "dayjs";

import { useMediaQuery, useTheme } from "@mui/material";

import { tonsToLbs, tonsToKgs } from "@aclymatepackages/converters";

export const generateRandomPin = () =>
  Math.floor(100000 + Math.random() * 900000);

export const isObjectEmpty = (obj) => {
  if (!obj || typeof obj !== "object") {
    return true;
  }
  return !Object.keys(obj).length;
};

export const generateTempId = () => dayjs().unix() * Math.random();

export const generateSecureId = () => crypto.randomUUID();

export const useLayoutHelpers = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isMedium = useMediaQuery(theme.breakpoints.down("lg"));

  const standardBoxPadding = {
    px: isMobile ? 1 : isMedium ? 2 : 8,
    py: isMobile ? 5 : 8,
  };

  return { theme, isMobile, isMedium, standardBoxPadding };
};

export const sortOptionsAlphabetically = (options = [], key = "name") => {
  if (!options?.length) {
    return [];
  }

  return [...options].sort((a, b) => {
    if (a[key] < b[key]) {
      return -1;
    }
    if (b[key] < a[key]) {
      return 1;
    }
    return 0;
  });
};

export const carbonUnitTypes = [
  {
    name: "Pounds",
    short: "lbs",
    converter: (tons) => (tons ? tonsToLbs(tons) : 0),
  },
  {
    name: "Kilograms",
    short: "kgs",
    converter: (tons) => (tons ? tonsToKgs(tons) : 0),
  },
  { name: "Tonnes", short: "tons", converter: (tons) => tons },
];

export const convertDataToCsv = (formattedRows, header) => {
  const csvRows = formattedRows
    .map(
      (row) =>
        Object.values(row)
          .map((string) => (string ? `"${string}"` : ""))
          .join(",") + "\r\n"
    )
    .join("");

  return new Blob([`${header}\r\n${csvRows}`], { type: "text/csv" });
};

export const getUrlSearchParams = (param) =>
  new URLSearchParams(window.location.search).get(param);

// Invite links embed an access-granting inviteToken as a query param (see
// inviteExplorerTeamMember/linkUserToVendor) -- reporting window.location.href
// verbatim (e.g. the global unhandledrejection handler in src/index.js) would
// leak it into error telemetry. Strip any URL params this app ever puts a
// token/secret in before a URL is sent anywhere outside the browser.
const SENSITIVE_URL_PARAMS = ["inviteToken"];

export const stripSensitiveUrlParams = (href) => {
  try {
    // href may be a relative path (e.g. a react-router breadcrumb's "to"
    // field, like "/explorer?inviteToken=...") rather than an absolute URL --
    // the URL constructor requires a base to parse those, which also lets a
    // genuinely malformed/empty input still throw and fall through below.
    const url = new URL(href, window.location.origin);
    SENSITIVE_URL_PARAMS.forEach((param) => url.searchParams.delete(param));
    return href.startsWith(url.origin)
      ? url.toString()
      : `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return href;
  }
};
